/**
 * @todo: rename me -> NavigationController ?
 */
export class NavigationState {
    private callback:Function;

    private _limit:number;
    private _offset:number;
    private _count:number;

    private _nextDisabled:boolean;
    private _prevDisabled:boolean;
    private _beginningDisabled:boolean;
    private _endDisabled:boolean;

    private _label:string;

    get limit():number { return this._limit; }
    get offset():number { return this._offset; }
    get count():number { return this._count; }

    get nextDisabled():boolean { return this._nextDisabled; }
    get prevDisabled():boolean { return this._prevDisabled; }
    get beginningDisabled():boolean { return this._beginningDisabled; }
    get endDisabled():boolean { return this._endDisabled; }

    get label():string { return this._label; }


    constructor(callback:Function, limit:number = 15) {
        this.callback = callback;

        this._offset = 0;
        this._count = -1;
        this._limit = limit;
    }


    update(newOffset:number, newCount:number) {
        this._offset = newOffset;
        this._count = newCount;
        this.updateState();
    }


    tryNext() {
      console.log('try next');
      console.log(this._offset );
      console.log(this._limit );
      console.log(this._count );
        if (this._offset + this._limit >= this._count) {
            return;
        }

        this._offset += this._limit;
        this.notify();
    }


    tryPrev() {
        let prevOffset = this._offset;
        this._offset -= this._limit;
        if (this._offset < 0) {
            this._offset = 0;
        }

        if (this._offset === prevOffset) {
            return;
        }

        this.notify();
    }


    tryBeginning() {
        if (this._offset === 0) {
            return;
        }

        this._offset = 0;
        this.notify();
    }


    tryEnd() {
        let diff = this._count % this._limit;
        let n = Math.floor((this._count - diff) / this._limit);
        if (diff === 0 && n > 0) {
            n -= 1;
        }
        this._offset = n * this._limit;
        this.notify();
    }


    /**
     * Same as 'tryEnd' but with one extra item!
     */
    prepareToShowLastPage() {
        let newCount: number = this._count + 1;
        let diff = newCount % this._limit;
        let n = Math.floor((newCount - diff) / this._limit);
        if (diff === 0 && n > 0) {
            n -= 1;
        }
        this._offset = n * this._limit;
    }


    private updateState():void {
        let numPages = Math.ceil(this._count / this._limit);
        let currentPage = Math.floor(this._offset / this._limit);

        //console.log(`[navigation-state.updateState] numPages: ${numPages}, curr: ${currentPage}, offset: ${this._offset}, count: ${this._count}`);

        this._prevDisabled = currentPage <= 0;
        this._nextDisabled = currentPage >= numPages - 1;
        this._beginningDisabled = currentPage <= 0;
        this._endDisabled = currentPage >= numPages - 1;

        this._label = `${this._offset}...${this._limit + this._offset}/${this._count}`;

        // note: out of bound !!
        if (this._offset > this._count) {
            this._offset = 0;
            this.notify();
        }
    }

    private notify() {
        this.callback();
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/navigation-state.ts